module.exports = __webpack_public_path__ + "img/2022_10_dandelion_almurabaa_fin_web.713dca72.png";